function getWishlist(){
 return JSON.parse(localStorage.getItem("wishlist")) || [];
}

function saveWishlist(list){
 localStorage.setItem("wishlist", JSON.stringify(list));
}

function toggleWishlist(handle,btn){

 let wishlist = getWishlist();

 const index = wishlist.indexOf(handle);

 if(index > -1){

   wishlist.splice(index,1);

 }else{

   /* prevent duplicate push */
   if(!wishlist.includes(handle)){
     wishlist.push(handle);
   }

 }

 saveWishlist(wishlist);

 updateWishlistCount();
 updateHeartIcons();
 if(btn){
   btn.classList.add("wishlist-bounce");
   setTimeout(()=> btn.classList.remove("wishlist-bounce"),400);
 }
 openWishlistDrawer();

 //loadWishlistDrawer();

}



function removeFromWishlist(handle, element){

 let wishlist = getWishlist();

 wishlist = wishlist.filter(p => p !== handle);

 saveWishlist(wishlist);

 let cache = getProductCache();
 delete cache[handle];
 saveProductCache(cache);

 updateWishlistCount();
 updateHeartIcons();

 element.style.transition="all .3s ease";
 element.style.opacity="0";
 element.style.transform="translateX(40px)";

 setTimeout(()=>{
   element.remove();
 },300);

}

function updateWishlistCount(){

 const wishlist = getWishlist();

 const badge = document.querySelector(".wishlist-count");

 if(!badge) return;

 badge.textContent = wishlist.length;

 badge.classList.add("wishlist-bounce");

 setTimeout(()=>{
   badge.classList.remove("wishlist-bounce");
 },400);

}

function updateHeartIcons(){

  const wishlist = getWishlist();

  document.querySelectorAll(".wishlist-btn").forEach(btn => {

    const handle = btn.getAttribute("data-handle");
    const heart = btn.querySelector(".wishlist-heart");

    if(!heart) return;

    if(wishlist.includes(handle)){
      btn.classList.add("saved");
      heart.innerHTML = "♥";
    }else{
      btn.classList.remove("saved");
      heart.innerHTML = "♡";
    }

  });

}

async function loadWishlistPage(){

 const container = document.getElementById("wishlist-products");
 if(!container) return;

 const wishlist = getWishlist();
 const cache = getProductCache();

 if(!wishlist.length){
   container.innerHTML = "<p>Your wishlist is empty.</p>";
   return;
 }

 let html = "";

 for(const handle of wishlist){

   let product = cache[handle];

   if(!product){

     const res = await fetch(`/products/${handle}.js`);
     const data = await res.json();

     product = {
       handle:data.handle,
       title:data.title,
       price:data.price,
       image:data.images[0]
     };

     cache[handle] = product;

   }

   html += `
<div class="wishlist-card product-card-wrapper" style="margin-bottom: 20px;">
  <div class="card__inner" style="position: relative; overflow: hidden; border-radius: 4px 4px 0 0;">
    <a href="/products/${product.handle}" style="display: block;">
      <img src="${product.image}" alt="${product.title}" style="width: 100%; display: block; transition: transform 0.5s ease;" />
    </a>
  </div>

  <div class="card__content" style="padding: 15px; text-align: center; background: #fff;">
    <h3 class="card__heading" style="margin: 0 0 8px 0 !important;">
      <a href="/products/${product.handle}" style="text-decoration: none; color: #1a1a1a; transition: color 0.3s ease;">
        ${product.title}
      </a>
    </h3>

    <div class="price-container">
      <span style="font-family: 'Montserrat', sans-serif; font-weight: 700; color: #D4AF37; font-size: 15px; letter-spacing: 0.5px;">
        ₹${(product.price / 100).toLocaleString('en-IN')}
      </span>
    </div>
  </div>
</div>
`;


 }

 container.innerHTML = html;

 saveProductCache(cache);

}

function getProductCache(){
 return JSON.parse(localStorage.getItem("wishlistProducts")) || {};
}

function saveProductCache(cache){
 localStorage.setItem("wishlistProducts", JSON.stringify(cache));
}


async function loadWishlistDrawer(){

 const container = document.getElementById("wishlist-drawer-items");
 if(!container) return;

 container.innerHTML = "";

 const wishlist = getWishlist();
 const cache = getProductCache();

 if(!wishlist.length){
   container.innerHTML = "<p style='padding:20px'>No saved sarees yet.</p>";
   return;
 }

 let index = 0;

 for(const handle of wishlist){

   let product = cache[handle];

   /* fetch only if not cached */
   if(!product){

     try{

       const res = await fetch(`/products/${handle}.js`);
       const data = await res.json();

       product = {
         handle:data.handle,
         title:data.title,
         price:data.price,
         image:data.images[0]
       };

       cache[handle] = product;

     }catch(err){
       console.error("Wishlist fetch error:", err);
       continue;
     }

   }

   const html = `
   <div class="wishlist-drawer-item" data-handle="${product.handle}">
     <img src="${product.image}">
     <div class="wishlist-drawer-info">
       <p>${product.title}</p>
       <p>₹${product.price/100}</p>
     </div>
     <button class="wishlist-remove" data-handle="${product.handle}">✕</button>
   </div>
   <div class="wishlist-divider"></div>
   `;

   container.insertAdjacentHTML("beforeend", html);

   const item = container.lastElementChild;
   item.style.animationDelay = (index * 0.05) + "s";

   index++;

 }

 saveProductCache(cache);

}

/*async function loadWishlistDrawer11(){

const container = document.getElementById("wishlist-drawer-items");
if(!container) return;

container.innerHTML = "";

const wishlist = getWishlist();
if(!wishlist.length){
 container.innerHTML = "<p style='padding:20px'>No saved sarees yet.</p>";
 return;
}
const cache = getProductCache();

let html = "";

for(const handle of wishlist){

let product = cache[handle];

if(product){

 html += `
 <div class="wishlist-drawer-item" data-handle="${product.handle}">
   <img src="${product.image}">
   <div class="wishlist-drawer-info">
     <p>${product.title}</p>
     <p>₹${product.price/100}</p>
   </div>
   <button class="wishlist-remove" data-handle="${product.handle}">✕</button>
 </div>
 `;

 continue;

}

try{

 const res = await fetch(`/products/${handle}.js`);
 const data = await res.json();

 product = {
   handle:data.handle,
   title:data.title,
   price:data.price,
   image:data.images[0]
 };

 cache[handle] = product;

 html += `
 <div class="wishlist-drawer-item" data-handle="${product.handle}">
   <img src="${product.image}">
   <div class="wishlist-drawer-info">
     <p>${product.title}</p>
     <p>₹${product.price/100}</p>
   </div>
   <button class="wishlist-remove" data-handle="${product.handle}">✕</button>
 </div>
 `;

}catch(err){
console.error("Wishlist fetch error", err);
}

}

container.innerHTML = html;

saveProductCache(cache);

} */

function openWishlistDrawer(){

 document.getElementById("wishlist-drawer").classList.add("open");
 document.getElementById("wishlist-overlay").classList.add("active");

 document.body.style.overflow="hidden";

 loadWishlistDrawer();

}

function closeWishlistDrawer(){

 document.getElementById("wishlist-drawer").classList.remove("open");
 document.getElementById("wishlist-overlay").classList.remove("active");

 document.body.style.overflow="";

}

document.addEventListener("DOMContentLoaded", function(){

  updateWishlistCount();
  loadWishlistPage();

  /* run once */
  updateHeartIcons();

  /* run again after cards render */
  setTimeout(updateHeartIcons, 200);

   /* overlay click close */
  const overlay = document.getElementById("wishlist-overlay");
  if(overlay){
    overlay.addEventListener("click", closeWishlistDrawer);
  }

});


let wishlistClickLock = false;

document.addEventListener("click", function(e){

 const wishlistBtn = e.target.closest(".wishlist-btn");

 if(!wishlistBtn || wishlistClickLock) return;

 wishlistClickLock = true;

 setTimeout(()=>{
   wishlistClickLock = false;
 },200);

 e.preventDefault();
 e.stopPropagation();

 const handle = wishlistBtn.getAttribute("data-handle");

 toggleWishlist(handle, wishlistBtn);

});

document.addEventListener("click", function(e){

  const removeBtn = e.target.closest(".wishlist-remove");

  if(!removeBtn) return;

  const handle = removeBtn.getAttribute("data-handle");
  const item = removeBtn.closest(".wishlist-drawer-item");

  removeFromWishlist(handle, item);

});

document.addEventListener("click", function(e){

  const overlay = e.target.closest("#wishlist-overlay");

  if(!overlay) return;

  closeWishlistDrawer();

});



document.getElementById("wishlist-overlay").onclick = closeWishlistDrawer;

document.querySelector(".wishlist-close-btn")
  .addEventListener("click", closeWishlistDrawer);